import React from 'react';
import LeadAdvisorsPage from './LeadAdvisorsPage';

/** Platform admin: invite and list other platform administrators (own sidebar entry). */
const AdministratorsPage = () => <LeadAdvisorsPage kindKey="platform_admin" />;

export default AdministratorsPage;
